<div fxLayout="column" class="campaigns-wrapper">
 
  <div>
    <mat-toolbar fxFlex fxLayout="row">
      <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start start" [class.compact-header-text]="media.isActive('lt-sm')">
        <span class="mat-body-1 padding-right-5">
          {{ 'LABEL_RECORD_COUNT' | translate }}
        </span>
        <span class="mat-body-1">
         {{ listLength }}
        </span>
      </div>
 
      <div fxFlex fxLayout fxLayoutAlign="end center">
        <!-- Search Bar -->
        <!-- <form 
          novalidate           
          autocorrect="off"
          [formGroup]="form"           
          autocomplete="off"
          >

          <mat-form-field 
            floatLabel="never" 
            class="max-width-160"
            [style.font-size.px]="media.isActive('lt-sm') ? '12' : '14'"
            >

            <input 
              matInput 
              #searchTerm
              formControlName="searchTerm"
              [placeholder]="'LABEL_SEARCH' | translate"
              >

            <mat-icon 
              matSuffix
              color="primary"
              class="clear-input"
              svgIcon="close-circle"
              *ngIf="searchTerm.value"
              [matTooltip]="'LABEL_CLEAR' | translate"
              (click)="form.get('searchTerm').setValue('')"
              >
            </mat-icon>
          </mat-form-field>
        </form> -->

        <button mat-icon-button [matTooltip]="'LABEL_REFRESH' | translate" [disabled]="loading.init || loading.more" (click)="refresh()">
          <mat-icon svgIcon="refresh"></mat-icon>
        </button>
 
        <button [class.filter-color]="filterNumber > 0" mat-icon-button [matTooltip]="'LABEL_FILTER' | translate" [disabled]="loading.init || loading.more" (click)="openFilter()">
          <mat-icon svgIcon="filter-variant"></mat-icon>
        </button>
 
        <button 
          mat-icon-button 
          (click)="download()"
          [disabled]="!listData?.length"
          [matTooltip]="'LABEL_DOWNLOAD_TEMPLATE' | translate" 
          *ngIf="authService.hasPermission('OPD' + constants.PERMISSION_STRINGS.download)"
          >
          <mat-icon svgIcon="download"></mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>
 
  <div fxLayout="column" infiniteScroll (scrolled)="getMoreData()" [scrollWindow]="false" class="report-table-wrapper" *ngIf="!loading.init && listData?.length" [class.empty-report]="!listData?.length" fxFlex>
    <div>
      <table mat-table [dataSource]="listData">
        <!-- TBL_HDR_CHAIN_CODE -->
        <ng-container matColumnDef="chain_code">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_CHAIN_CODE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.chain_code }}
          </td>
        </ng-container>

        <!-- TBL_HDR_CHAIN_NAME -->
        <ng-container matColumnDef="chain_description">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_CHAIN_NAME' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.chain_name }}
          </td>
        </ng-container>
 
        <!-- TBL_HDR_BRANCH_CODE -->
        <ng-container matColumnDef="branch_code">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_BRANCH_CODE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.branch_code }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_BRANCH_NAME -->
        <ng-container matColumnDef="branch_description">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_BRANCH_NAME' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.branch_name }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_CATEGORY_CODE -->
        <ng-container matColumnDef="category_code">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_CATEGORY_CODE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.category_code }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_CATEGORY_NAME -->
        <ng-container matColumnDef="category_description">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_CATEGORY_NAME' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.category_name }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_BRAND_CODE -->
        <ng-container matColumnDef="brand_code">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_BRAND_CODE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.brand_code }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_BRAND_NAME -->
        <ng-container matColumnDef="brand_description">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_BRAND_NAME' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.brand_name }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_ITEM_CODE -->
        <ng-container matColumnDef="item_code">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_ITEM_CODE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.sku_code }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_ITEM_NAME -->
        <ng-container matColumnDef="item_description">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_ITEM_NAME' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.sku_name }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_PRICE -->
        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_PRICE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.price_amount }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_EFF_START_DATE -->
        <ng-container matColumnDef="effectivity_start_date">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_EFF_START_DATE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.start_date }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_EFF_END_DATE -->
        <ng-container matColumnDef="effectivity_end_date">
          <th mat-header-cell *matHeaderCellDef [innerHtml]="'TBL_HDR_EFF_END_DATE' | translate"></th>
          <td mat-cell *matCellDef="let element"> 
            {{ element?.end_date }}
          </td>
        </ng-container>    
 
        <!-- TBL_HDR_STATUS -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'TBL_HDR_STATUS' | translate}}</th>
          <td mat-cell *matCellDef="let element">
            {{element?.status}}
          </td>
        </ng-container>
 
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
 
  <div *ngIf="!loading.error && !loading.init && !listData?.length" fxFlex fxLayout="column" fxLayoutAlign="center center">
    <mat-icon color="primary" svgIcon="information-outline" class="size-48"></mat-icon>
    <span class="mat-body" [class.compact-header-text]="media.isActive('lt-sm')">
      {{ 'LABEL_NO_DATA' | translate}}
    </span>
  </div>
 
  <div *ngIf="loading.error && !loading.init && !listData?.length" fxLayoutGap="20px" fxFlex fxLayout="column"
    fxLayoutAlign="center center">
    <mat-icon color="warn" svgIcon="alert-circle-outline" class="size-48"></mat-icon>
    <span class="mat-body">
      {{ 'MSG_ERROR_NETWORK_CONNECTION' | translate }}
    </span>
    <button color="primary" mat-raised-button (click)="refresh()">
      {{ 'LABEL_RETRY' | translate }}  
    </button>
  </div>
  
  <div *ngIf="loading.init || loading.more || loading.download" fxFlex fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-report">
    <mat-spinner></mat-spinner>
  </div>
  
</div>